const en = {
  home: 'Home',
  nextText: 'Next',
  hijriShortcut: 'Hijri',
  latinDateShortcut: 'A.D',
  cancelText: 'Cancel',
  newest: 'newest',
  oldest: 'oldest',
  requests: 'Requests',
  or: 'Or',
  dashboard: 'Dashboard',
  judicialLicenses: 'Judicial Licenses',
  verificationServices: 'Verification services',
  fetchingData: 'Fetching data in progress',
  noDataFound: 'No search results found',
  marriageOfficials: 'Marriage officials',
  marriageOfficialLicense: 'Marriage official license',
  licenseRequests: 'License requests',
  noLicensesFound: 'No licenses found',
  noRequestsFound: 'No requests found',
  newRequest: 'New request',
  procedures: 'Procedures',
  requestNewAuthorizedLicense: 'Request a new authorized license',
  editNewAuthorizedLicenseRequest: 'Edit new authorized license request',
  previewNewAuthorizedLicenseRequest: 'Preview new authorized license request',
  renewLicenseRequest: 'Renew license request',
  editRenewLicenseRequest: 'Edit renew license request',
  previewRenewLicenseRequest: 'Preview renew license request',
  reregisterLicenseRequest: 'Reregister license request',
  editReregisterLicenseRequest: 'Edit reregister license request',
  previewReregisterLicenseRequest: 'Preview reregister license request',
  reissueLicenseRequest: 'Reissue license request',
  editReissueLicenseRequest: 'Edit reissue license request',
  previewReissueLicenseRequest: 'Preview reissue license request',
  applicantPersonalInfo: 'Applicant personal info',
  requestReview: 'Request review',
  viewRequestDetails: 'View Request Details',
  theName: 'Name',
  anotherContactPerson: ['First Person', 'Second Person'],
  idNumber: 'ID number',
  dateOfBirth: 'Date of birth',
  phone: 'Phone',
  email: 'Email',
  socialMediaAccounts: 'Social media accounts',
  twitterId: 'Twitter Id',
  twitterConsent: 'I do not have an X (twitter previously) account',
  facebookId: 'facebook Id',
  facebookConsent: 'I do not have a facebook account',
  alert: 'Alert',
  qualificationDescription: 'A university qualification (Bachelor degree) in Sharia sciences is required to be attached',
  jobAndQualification: 'Job and qualifications',
  state: 'State',
  degree: 'Degree',
  university: 'University',
  universityName: 'University Name',
  college: 'College',
  collegeName: 'College Name',
  specialization: 'Specialization',
  specializationName: 'Specialization Name',
  jobTitle: 'Job title',
  qualificationDoc: 'Qualification document',
  attachments: 'Attachments',
  toUpdateYourNationalAddress: 'To update your national address',
  pleaseClickHere: ' please click here ',
  personalImageTitle: 'Personal image 4 * 6',
  residenceAddress: 'Residence address',
  city: 'City',
  neighborhood: 'Neighborhood',
  street: 'Street',
  buildingNumber: 'Building number',
  additionalNumber: 'Additional number',
  zipCode: 'zipCode',
  addQualification: 'Add qualification',
  saveText: 'Save',
  youDoNotHaveQualification: 'You do not have any qualifications.',
  certificateEquivalencyCopy: 'Certificate equivalency copy',
  splWebsite: 'the Saudi Post website, Subul from here',
  youDoNotHaveNationalAddressMessage: 'Dear beneficiary, an application could not be completed because you do not have a national address for you. Please create a national address via',
  notValidSelectedAddress: 'Dear beneficiary, your request could not be completed because part of the national address information was not available. Please update your national address via',
  searchingForNationalAddresses: 'searchingForNationalAddresses',
  prevText: 'Previous',
  backText: 'Back',
  saveRequestText: 'Save request',
  editRequestText: 'Edit request',
  renewRequest: 'Renew request',
  reregisterRequest: 'Reregister request',
  reissueRequest: 'Reissue request',
  marriageOfficialLicenseCancellation: 'marriage Official License Cancellation',
  absherVerificationText: 'please enter verification code sent to your phone registered on abshir',
  remainingOtpTime: 'remaining time',
  resendOtp: 'resend Otp',
  verify: 'verify',
  cancellationReason: 'cancellation reason',
  otpRegenerationFailed: 'Otp regeneration failed',
  otpVerificationFailed: 'Otp verification failed',
  cancellationDocument: 'License Cancellation Attachment',
  cancelRequestConfirmation: 'Cancel request confirmation',
  cancelRequestConfirmationText: 'Cancel request confirmation Text',
  confirm: 'confirm',
  reissueRequestSubmittedSuccessfully: 'Reissue request submitted successfully',
  reissueRequestEdittedSuccessfully: 'Reissue request editted successfully',
  yourAddressHasBeenUpdatedFromWasel: 'Please note that address has been updated from your National address',
  authenticateMarriageContract: 'Authenticate marriage contract',
  newMarriageOfficalsRequest: 'New marriage officals request',
  medicalExamination: 'Medical examination',
  writtenTest: 'Written test',
  medicalExaminationText: 'Medical examination text',
  failedToDownloadMedicalExamination: 'Failed to download medical examination',
  writtenTestText: 'Written Test text',
  licensorsGuide: 'Licensors Guide',
  eServices: 'Electronic Services',
  saveChanges: 'Save changes',
  unAvailable: 'Unavailable',
  requestInfo: 'request data',
  viewRequest: 'View request data',
  newLicenseRequest: 'Request a new license',
  cancelLicenseRequest: 'Cancel an authorized license',
  cancelLicenseRequestDetails: 'License cancellation details',
  editRequestView: 'Edit request data',
  personalInfo: 'Personal data',
  newRequestSubmittedSuccessfully: 'The request was submitted successfully',
  marriageOfficialGuide: 'Guide to marriage officials',
  addTheQualification: 'Add the qualification',
  newRequestEditedSuccessfully: 'The request was modified successfully',
  renewRequestSubmittedSuccessfully: 'The license renewal request has been submitted successfully',
  youCanAddOnlyOneQualification: 'Only one qualification can be added',
  renewRequestEditedSuccessfully: 'The license renewal request has been successfully modified',
  personalPicture: 'Color personal photo',
  academicQualificationCopy: 'Copy of academic qualification',
  licenseSuspension: 'Reason for license suspension',
  rejectionReason: 'Rejection decision',
  reregisterRequestSubmittedSuccessfully: 'The re-enrollment request was submitted successfully',
  contactInfo: 'contact information',
  contactInfoTitle: 'Two people to contact',
  contactInfoDescription: 'People who can be contacted if the applicant cannot be reached',
  pleaseAddQualifications: 'Please add an academic qualification',
  youDoNotHaveNationalAddress: 'You do not have a registered national address!',
  reregisterRequestEditedSuccessfully: 'The re-registration request has been successfully modified',
  qualifications: 'academic qualifications',
  cancelRequest: 'Cancel request',
  NoRejectionReasons: 'There are no reasons to display',
  downloadRequestDecision: 'Download rejection decision',
  chooseYourAddress: 'Choose your national address',
  medicalExaminationError: 'You cannot upload a paper copy',
  jobTitlePlaceholder: 'Enter job title',
  mobilePlaceholder: '05xxxxxxxx',
  emailPlaceholder: 'Example: name@domain.com',
  personalPhoto: 'personal photo',
  personName1: 'Person\'s first name',
  personName2: 'Name of second person',
  fromHere: 'From here',
  personMobile1: 'Mobile number of the first person',
  personMobile2: 'The second person\'s mobile number',
  personName: 'person name',
  pleaseChoose: 'Please choose',
  serviceDocuments: 'Service Documents',
  toCompleteTheRequestAttach: 'In order to be able to complete the request, the attachments must be present',
  iHaveRead: 'I acknowledge that I have read',
  termsAndConditions: 'Terms and Conditions',
  socialAccountPlaceholder: 'Account ID',
  theAddress: 'Address',
  number: 'number',
  edit: 'Edit',
  retreat: 'retreat',
  confirmRequest: 'Confirm order',
  delete: 'Delete',
  pleaseChooseYourAddress: 'Please choose your national address from the list above',
  saveAndNextText: 'Save and continue',
  cancelTheLicense: 'Cancel the license',
  cancelNotePlaceholder: 'Write the reason for requesting cancellation of the license',
  withMaxLengthChars: 'with max {length} character',
  enterCodeSentToID: 'Enter the 4 numbers sent to phone number registered on id number {idNumber}',
  cancellationRequestConfirmTitle: 'Request to cancel authorized license number {licenseNumber}',
  cancellationRequestConfirmMessage: 'Are you sure you want to cancel the license?',
  editCancellationRequestConfirmMessage: 'Are you sure you want to edit the license cancellation?',
  verification: 'Verification',
  requestSuccededPlaceholderTitle: '{requestTypeName} submitted successfully',
  requestSuccededPlaceholderText: 'Your request for {requestNumber} has been received and you will be notified if the request status is updated',
  requestDetails: 'Request details',
  backToHome: 'Back to Home',
  viewRequestStatus: 'View request status',
  updateMarriageOfficialData: 'Update Marriage Official Data',
  updateLicenseRequest: 'Update License Data',
  editUpdateLicenseRequest: 'Edit Update License Data Request',
  previewUpdateLicenseRequest: 'Preview Update License Data Request',
  chooseServiceType: 'Choose Service Type',
  updatePersonalInfo: 'Update Marraige Official Personal Info',
  useService: 'Use Service',
  updateNameRequest: 'Update Name',
  editUpdateNameRequest: 'Edit Update Name Request',
  previewUpdateNameRequest: 'Preview Update Name Request',
  personalPhotoHelperText: 'The file type must be (jfif - pjpeg - jpeg - pjp - jpg - png) and a maximum size of 1 MB',
  backToLicenses: 'Back to Licenses',
  requestAttachmentHelperText: 'The file type must be (pdf - jfif - pjpeg - jpeg - pjp - jpg - png) and a maximum size of 5 MB',
  qualificationAttachmentHelperText: 'The file type must be (pdf - jfif - pjpeg - jpeg - pjp - jpg - png) and a maximum size of 5 MB',
  deleteQualificationConfirmation: 'Delete qualification?',
  deleteQualificationConfirmationText: 'Are you sure you want to delete the qualification “{name}”?',
  sendTheRequest: 'Send Request',
  nationalAddressAlertTitle: 'The service could not be completed',
  noResultFound: 'Sorry, No Result Matching your inputs',
  pleaseVerifyYourInputs: 'Please verify the data and try again.',
  nafathVerification: 'Nafath Verification',
  validations: {
    fieldIsRequired: 'Field is required',
    onlyNumbers: 'Please enter numbers only',
    maxInputsLength: 'Max inputs length {length}',
    numbersExactLength: 'Numbers exact length {length}',
    startsWith: 'Should start with {listText}',
    phoneNumber: 'Phone number should start with number {key} and it should be {length} digits',
    emailAddress: 'Please enter valid email',
    onlyArabicAndNumbers: 'Please enter arabic letters and numbers only',
    onlyArabicOrNumbers: 'Please enter arabic letters or numbers only',
    specialCharacters: 'Please do not entre special characters',
    twitterId: 'Id should looks like http(s)://twitter.com/xyz123',
    facebookId: 'Id should looks like http(s)://facebook.com/xyz123',
    minWordsLength: 'Words min length should be {length}',
    theNameMustBeBinary: 'The name must be binary',
    onlyArabic: 'Value should be arabic',
    duplicatePhoneNumberInContactInfo: 'Duplicate phoneNumber in contact info section',
    duplicatePhoneNumberInApplicantInfo: 'Duplicate phoneNumber in applicant info section',
    alphaNumeric: 'Please enter english letters and numbers only.',
    alphaNumericAndSpecialChars: 'Please enter english letters, numbers and special characters only like {chars}.',
  },
  licenseAndDetails: {
    licenseNumber: 'License Number',
    licenseType: 'License Type',
    licenseStatus: 'License Status',
    creationDate: 'Creation Date',
    expiryDate: 'Expiration Date',
    title: 'Marriage Official License',
    active: 'Active',
    inActive: 'Not Active',
    licenseDetails: 'License Details',
    downloadLicense: 'Download License',
    softLienseCopy: 'You can not download paper version license',
    issueLicense: 'IssueLicense',
    requestRecieved: 'Request Received',
    requestApproved: 'Request Approved',
    requestSteps: 'Request History',
    backToRequests: 'Back to Requests',
    reIssueLicense: 'ReIssue the License',
  },
  marriageOfficialList: {
    licenceNumber: 'License Number',
    licenceType: 'License Type',
    licenceStatus: 'License Status',
    licenseSearch: 'Search by License Number',
    emptyListTitle: 'No License To View',
    creationDate: 'Creationg Date',
    expiryDate: 'Expiration Date',
    action: 'License Action',
    title: 'Marriage Officials',
    tabTitle: 'Marriage Official License',
    newRequest: 'New License Request',
    renewLicenseRequest: 'Renew License Request',
    renewLicense: 'Renew Marriage Official License',
    search: 'Search',
    titleSearch: 'Search Filteration',
    clear: 'Clean the Fields',
    searchBtn: 'Search',
    actions: 'Show',
    view: 'View The Request',
    viewLicense: 'View The License',
    directoryOfLicensors: 'Marriage Officials List ',
    marriageOfficialGuide: 'Marriage Officials List',
    licensorsGuide: 'Licensors guide',
    reRegisterLicense: 'Re-register Marriage Offical License',
    cancelLicneseRequest: 'Cancel License Request',
    cancelLicnese: 'Cancel the License',
    reissuelLicnese: 'Reissue License Request',
    requestMarriageOfficalLicense: 'Marriage Offical License Request',
    reIssueMarriageOfficalLicense: 'Reissue Marriage Offical License',
    updateMarriageOfficalData: 'Update Marriage Offical Data',
    updateMarriageOfficalName: 'Update Marriage Offical Name',
    renewMarriageOfficalLicense: 'Renew Marriage Offical License',
    reRegisterMarriageOfficalLicense: 'Re-register Marriage Offical License',

    requestTypeCompleted: 'Completed',
    requestTypeReturenToComplete: 'Return to Complete',
    requestTypeInProcessing: 'Under Processing',
    requestTypeUnderReview: 'Under Review',
    requestTypeRejected: 'Rejected',
    requestTypeDraft: 'Draft',
    requestTypeNew: 'New',
    requestTypeInComplete: 'Incomplete',
    requestsSearch: 'Search by Request Number',
    sortAs: 'Sort By',
  },
  marriageOfficialRequestsList: {
    requestNumber: 'Request Number',
    requestDate: 'Request Date',
    requestStatus: 'Request Status',
    requestType: 'Request Type',
    view: 'View The Request',
    edit: 'Edit The Request',
    uncompleteResons: 'Uncomplete Reasons',
    delete: 'Delete The Request',
    newRequest: 'New License Request',
    renewLicense: 'Renew License Request',
    reRegisterLicense: 'ReRegister License Request',
    cancelLicnese: 'Cancel License',
    editCancelRequest: 'edit cancel request',
    viewClosingReasons: 'View Closing Reasons',
  },
  marriageOfficicalsGuide: {
    mobile: 'Mobile Number',
    address: 'Address',
    contractType: 'Contract Type',
    court: 'Court',
    loadCities: 'Load Cities',
    loadDistricts: 'Load Districts',
    loadMarriageOfficials: 'Load marriage Officials Guide',
    licenseStatus: 'Active',
    licenseNumber: 'License Number',
  },
  telemetry: {
    licensesRequests: 'licenses Requests',
    marriageOfficialsLicenses: 'marriage Officials Licenses',
    submitNewRequest: 'marriage Officials new request',
    submitRenewRequest: 'marriage Officials Renew request',
    submitReregisterRequest: 'marriage Officials Reregister request',
    fetchRequestDetails: 'Fetch request details',
    fetchLicenseData: 'Fetch license data',
    licenseCancellation: 'Marriage Officials License Cancellation Request',
    licenseCancellationPreview: 'Marriage Officials License Cancellation Preview',
    licenseDetailsPreview: 'License Details',
    submitReissueRequest: 'Submit reissue request',
  },
  requestStatusesMessages: {
    pendingCommitteeHead: 'Pending Committee Head Approval',
    closed: 'Closed',
  },
  serverErrors: {
    NOT_FOUND: 'We cannot serve you at the moment. Please try again later',
    SERVER_ERROR: 'Something went wrong, please try again later',
    LICENSE_DOCUMENT_NOT_FOUND: 'Papers License are not allowed to download',
  },
  pleaseUpdateOneFieldToCompleRequest: 'Please update at least one field to complete your request',
};

export default en;
